import { Img, Text, Heading } from "./..";
import React, { useState } from "react";


export default function WorkExperienceItem({
  workTitle,
  startDate,
  endDate,
  jobTitle,
  jobDescription,
  companyName,
  illustrationSrc,
  position = "left",
  ...props
}) {
  return (
    <div {...props} className={`${props.className} flex items-center flex-1 container-xs`}>

      <div className="grid grid-cols-12">
        {position == "right" &&
          <Img src={illustrationSrc} alt="Image" className="md:hidden col-start-0 flex justify-center ml-12 col-span-2 md:hidden w-full object-cover md:w-full" />
        }
        <div className={(position == "right" ? "col-start-4 " : "") + " md:grid md:grid-cols-2 md:items-center col-span-2 md:col-span-12 md:col-span-10 grid grid-cols-1 gap-28 rounded-bl-[50px] rounded-tl-[50px] md:rounded-bl-[0px] md:rounded-t-[50px] bg-blue_gray-900 px-[26px] py-[38px] md:gap-[87px] sm:gap-[58px] sm:p-5"}>
          <Heading
            size=""
            as="h1"
            className="text-center text-4xl  font-bold text-orange-a200 md:text-xl"
          >
            {startDate}
          </Heading>
          <Heading
            size=""
            as="h1"
            className="text-center text-4xl  font-bold text-orange-a200 md:text-xl"
          >
            {endDate}
          </Heading>
        </div>

        <div className={(position == "right" ? "col-start-6" : "") + " col-span-8 grid grid-cols-1 md:col-span-12"}>
          <div className="grid grid-cols-2 items-center justify-center gap-[30px] rounded-tr-[50px] md:rounded-tr-[0px] bg-blue_gray-900 p-3 pr-6">
            <Heading
              size=""
              as="h1"
              className="font-bold text-white-a700 text-5xl md:text-2xl"
            >
              {jobTitle}
            </Heading>
            <Heading
              size="headings"
              as="h3"
              className="text-right font-bold text-white-a700 text-3xl md:text-xl"
            >
              {companyName}
            </Heading>
          </div>

          <div className="rounded-br-[50px] md:rounded-b-[50px] bg-blue_gray-800 px-4 py-3 sm:py-5">
            <Text
              as="p"
              className="w-[98%] text-[31px] font-normal leading-10 text-white-a700 md:text-[29px] sm:text-[27px]"
            >
              {jobDescription}
            </Text>
          </div>
        </div>
        {position == "left" &&
          <Img src={illustrationSrc} alt="Image" className="md:hidden flex justify-center ml-12 col-span-2 md:hidden w-full object-cover md:w-full" />
        }
      </div>
    </div>
  );
}
